import { store } from "@src/core/store";
import { assert } from "radashi";
import { LoaderFunctionArgs, redirect } from "react-router";

export function TechnicalSelectionSubProductsLoader({
  params,
  request,
}: LoaderFunctionArgs) {
  assert(params.category, "Category param is required");
  assert(params.projectId, "Project ID param is required");
  const url = new URL(request.url);
  const encodedProductId = url.searchParams.get("productId");
  if (!encodedProductId) {
    throw redirect(
      `/projects/${params.projectId}/selections/technical/${params.category}`,
    );
  }

  const productId = decodeURIComponent(encodedProductId);
  const technicalSelection = store.getState().technicalSelection;
  const selection = technicalSelection.selections[productId];
  const categoryFilters = technicalSelection.categoryFilters;
  if (!selection || !categoryFilters) {
    throw redirect(
      `/projects/${params.projectId}/selections/technical/${params.category}`,
    );
  }
  return { productId };
}
